// Tipos de acción del "Tablero de Retrospectiva colaborativo" (spec 006). Molde de fetch:
// redux/briefcaseArtifacts/ (LOADING_X/LOAD_X/ERROR_X), extendido con lo mínimo necesario para updates
// optimistas (RF-16, plan.md §3.2): parchear una tarjeta (voto/like/edición) o reemplazar el orden de una
// columna completa, con rollback simétrico (mismo tipo de acción, valores anteriores) cuando el backend
// rechaza el cambio (409 NO_VOTE_BUDGET / BOARD_CLOSED).

export const LOADING_RETRO_BOARDS = "LOADING_RETRO_BOARDS";
export const LOAD_RETRO_BOARDS = "LOAD_RETRO_BOARDS";
export const ERROR_RETRO_BOARDS = "ERROR_RETRO_BOARDS";

export const LOADING_RETRO_BOARD_DETAIL = "LOADING_RETRO_BOARD_DETAIL";
export const LOAD_RETRO_BOARD_DETAIL = "LOAD_RETRO_BOARD_DETAIL";
export const ERROR_RETRO_BOARD_DETAIL = "ERROR_RETRO_BOARD_DETAIL";
export const RESET_RETRO_CURRENT_BOARD = "RESET_RETRO_CURRENT_BOARD";

export const SET_RETRO_TABLERO = "SET_RETRO_TABLERO";
export const SET_RETRO_VOTANTES = "SET_RETRO_VOTANTES";

// Tarjetas: alta/baja optimista + parche genérico (texto, agregados de voto/like).
export const ADD_RETRO_CARD = "ADD_RETRO_CARD";
export const REMOVE_RETRO_CARD = "REMOVE_RETRO_CARD";
export const RESTORE_RETRO_CARD = "RESTORE_RETRO_CARD";
export const PATCH_RETRO_CARD = "PATCH_RETRO_CARD";
export const SET_RETRO_COLUMN_CARDS = "SET_RETRO_COLUMN_CARDS";
